import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { MainStore } from '@vue/services/store';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Store',
    setup(__props) {
        function store(...args) {
            return args ? 'store-viewer' : '';
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(store(_unref(MainStore)))
            }, null, 2));
        };
    }
});
